<template>
    <section class="slice slice-trends-gaps" :class="{'slice-trends-gaps--grey': backgroundColor === 'grey'}">
        <div class="slice-content">
            <PrismicRichText class="slice-trends-gaps__title" :field="props.slice.primary.title" />
            <div class="slice-trends-gaps__columns">
                <div v-for="(column, index) in props.slice.primary.columns" :key="`trends-gaps-${index}`" class="slice-trends-gaps__column">
                    <h3 class="slice-trends-gaps__subtitle">{{ column.title }}</h3>
                    <PrismicRichText :field="column.list" />
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import type {Content} from '@prismicio/client';

    import {getSliceComponentProps, PrismicRichText} from '@prismicio/vue';

    const props = defineProps(getSliceComponentProps<Content.TrendsGapsSlice>(['slice', 'index', 'slices', 'context']));
    const backgroundColor = computed(() => props.slice.primary.backgroundColor);
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .slice-trends-gaps {
        &--grey {
            background-color: var(--joy-color-neutral-20);
        }

        &__title {
            margin-bottom: var(--joy-core-spacing-8);
            h2 {
                font-size: var(--joy-font-size-secondary-400);
                font-weight: var(--joy-font-weight-normal);
            }
        }
        &__subtitle {
            font-size: var(--joy-font-size-primary-600);
            margin-bottom: var(--joy-core-spacing-4);
        }
        &__columns {
            display: flex;
            flex-direction: column;
            gap: var(--joy-core-spacing-6);

            > * {
                padding-left: var(--joy-core-spacing-4);
                border-left: 2px solid var(--joy-color-primary-50);
            }

            ul {
                list-style: none;
                padding-left: 0;
                margin-left: 0;

                li {
                    position: relative;
                    padding-left: var(--joy-core-spacing-5);

                    &::before {
                        content: '\f120';
                        position: absolute;
                        left: 0;
                        top: var(--joy-core-spacing-1);
                        font-size: var(--joy-font-size-primary-200);
                        color: var(--joy-color-primary-50);
                        font-family: joy-icons !important;
                        font-weight: var(--joy-font-weight-bold);
                    }
                    margin-bottom: var(--joy-core-spacing-2);
                }
            }

            @include mq.screen_sm(min) {
                flex-direction: row;
                align-items: stretch;

                > * {
                    flex: 1 1 0%;
                }
            }
        }
    }
</style>
